import { useState } from "react";
import Option from "../../../types/Option";
import { isEmpty } from "../../../utils/isEmpty";
import { Input } from "../../Input";
import { Dropdown } from "../../Dropdown";
import { Button } from "../../Button";

export const ModalCreate = ({
  loading,
  collection,
  onCancel,
  onConfirm,
  hojasOptions,
}: any) => {
  const [min_hojas, setSheetCountMin] = useState<number>(0);
  const [max_hojas, setSheetCountMax] = useState<number>(0);
  const [selectedSheet, setSelectedSheet] = useState<any>(hojasOptions[0]);
  const [precio, setPrice] = useState<number>(0);

  const [errors, setErrors] = useState<any>({
    min_hojas: "",
    max_hojas: "",
    precio: "",
  });

  const onChangeSheetCountMin = (text: string) => {
    setSheetCountMin(Number(text));
  };

  const onChangeSheetCountMax = (text: string) => {
    setSheetCountMax(Number(text));
  };

  const onChangeSheet = (sheet: Option) => {
    setSelectedSheet(sheet);
  };

  const onChangePrice = (text: string) => {
    setPrice(Number(text));
  };

  const onClickConfirm = () => {
    let errors: any = {};

    if (isEmpty(min_hojas)) {
      errors = {
        ...errors,
        min_hojas: "Requerido",
      };
    }

    if (isEmpty(max_hojas)) {
      errors = {
        ...errors,
        max_hojas: "Requerido",
      };
    }

    if (isEmpty(precio)) {
      errors = {
        ...errors,
        precio: "Requerido",
      };
    }

    if (errors?.min_hojas || errors?.max_hojas || errors?.precio) {
      setErrors(errors);
    } else {
      onConfirm({
        min_hojas,
        max_hojas,
        sheet: selectedSheet.value,
        precio,
        collection,
      });
    }
  };

  return (
    <div>
      <Input
        disabled={loading}
        onChange={onChangeSheetCountMin}
        value={min_hojas}
        title="Cant. Papel Min"
        error={errors.min_hojas}
        mask={Number}
      />

      <Input
        disabled={loading}
        onChange={onChangeSheetCountMax}
        value={max_hojas}
        title="Cant. Papel Max"
        error={errors.max_hojas}
        mask={Number}
      />

      <Dropdown
        title="Hoja"
        className="margin-top"
        options={hojasOptions}
        value={selectedSheet.value}
        onChange={onChangeSheet}
      />

      <Input
        disabled={loading}
        onChange={onChangePrice}
        value={precio}
        title="Precio"
        error={errors.precio}
        mask={Number}
      />

      <div className="actions">
        <Button disabled={loading} outlined onClick={onCancel}>
          Cancelar
        </Button>
        <Button loading={loading} onClick={onClickConfirm}>
          Confirmar
        </Button>
      </div>
    </div>
  );
};
